import React from 'react'
import Element from 'layouts/Element'
import { Env } from '@morningtrain/helpers'
import Block from 'layouts/page/Block'

export default class Title extends Element {
  static get defaultProps () {
    return {}
  }

  get defaultClassNames () {
    return ['page-title', 'text-gray-900']
  }

  render () {
    return (
      <Block filled={false}>
        <h1 className={this.classNames}>
          {Env.get('page.title')}
        </h1>
      </Block>
    )
  }
}
